import { render, staticRenderFns } from "./TransportPage.vue?vue&type=template&id=7cbc6166&scoped=true"
import script from "./TransportPage.vue?vue&type=script&lang=js"
export * from "./TransportPage.vue?vue&type=script&lang=js"
import style0 from "./TransportPage.vue?vue&type=style&index=0&id=7cbc6166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbc6166",
  null
  
)

export default component.exports